module.exports = {

    toLogin:{
        loginTip:'登录提示',

        token:'登录过期,请重新登录',
        ifToLogin:'是否前往登录',
        canel:'取 消',
        confirm:'确 认',
    },
    DataSatName:{
        name1:'全球海洋漩涡',
        name2:'亚非沙漠蝗虫灾情监测与评估',
        name3:'全球海洋漩涡'
    },
    banner:{
        title:'Big Earth Data for SDGs',
        text1:'Digital connections, shared prosperity, for our people, for our planet.',
        text2:' Big earth data-driven innovations towards the Sustainable Development Goals, for a better world.',
    },
        // 导航菜单
    Nav: {
        Name: '一带一路地球大数据分析与决策支持系统',
        // Name:'数字丝路地球大数据平台',
        Menu: {
            Home: '首页',
            DataHub: '数据服务',
            Story:'SDGs故事',
            Featured:'最新动态',
            Society: 'SDGs与社会',
            Science: 'SDGs与科技',
            Practices: '实践案例',
            AppsMarket: '应用市场',
            Knowledgebase: 'SDGs知识库',
            MySpace: '个人空间',
            AboutUs: '关于',
            Contact: '联系我们',
            SDG: 'SDG中心概况',
            Language: '语言',
            ZH:'中文',
            EN:'英文',
            Indicators: '指标知识库',
            Reports: '报告',
            UnderDevelopment: '正在开发中',
        },
        User: {
            Login: '登录',
            Logout: '退出'
        }
    },
    Index: {
        Technology: {
            latest: '最近的'
        },
        Knowledge: {
            Indicators: 'SDGs指标知识库',
            Reports: 'SDGs报告',
            TerraViewSDGs: 'TerraView-SDGs'
        }
    },
    DataSerch:{
        key:'推荐词搜索',
        dataSearch:'数据搜索',
        filter:'筛选条件',
        geosphere:'地球圈层',
        format:'数据格式',
        source:'数据来源',
        more:'更多',
        sort:'排序',
        defaultSort:'默认排序',
        visits:'访问量',
        downloads:'下载量',
        lastUpdated:'最近更新时间',
        browsingData:'用户浏览数据',
        noData:'暂无数据',
       found:'条相关结果',
       Prefix:'为您找到',
       Collected:'已收藏'
    },
    DataServer:{
        sdg1:'无贫穷',
        sdg2:'零饥饿',
        sdg3:'良好健康与福祉',
        sdg4:'优质教育',
        sdg5:'性别平等',
        sdg6:'清洁饮水和卫生设施',
        sdg7:'经济适用的清洁能源',
        sdg8:'体面工作和经济增长',
        sdg9:'产业、创新和基础设施',
        sdg10:'减少不平等',
        sdg11:'可持续城市和社区',
        sdg12:'负责任消费和生产',
        sdg13:'气候行动',
        sdg14:'水下生物',
        sdg15:'陆地生物',
        sdg16:'和平、正义与强大机构',
        sdg17:'促进目标实现的伙伴关系',
        sharingPlatform:'分布式共享平台',
        platformStatistics:'数据访问统计',
        tagCloud:'标签云',
        mostPopular:'最受欢迎专区',
        dataClassification:'数据分类',
        topDataRanking:'热门数据排行榜',
        noData:'暂无数据',
        recentUpdates:'最近更新',
        dataVolume:'数据量',
        numberfiles:'文件数',
        views:'浏览量',
        downloads:'下载量',

        
    },
    MySpace:{
        downloadNum:'下载数',
        dataReserve:'数据预定',
        shopping:'购物车',
        collectNum:'收藏数',
        dataOrder:'数据订单',
        dataCollection:'数据收藏',
        batchReserve:'批量预定',
        batchDelete:'批量删除',
        reserve:'预定',
        delete:'删除',
        dataSatName:'数据集名称',
        dataID:'数据标识',
        createTime:'创建时间',
        Operation:'操作',
        orderNum:'订单编号',
        orderStatus:'订单状态',
        dataSize:'数据大小',
        orderTime:'订单时间',
        seen:'查看',
        thumbnail:'缩略图',
        canelCollect:'取消收藏',
        collectTime:'收藏时间',
        Finish:'完成',
        inPreparation:'准备中',
        ftp:{
            projectName:'任务名称',
            orderNum:'订单编号',
            status:'状态',
            adrees:'FTP地址',
            FTPaccount:'FTP账号',
            FTPpassword:'FTP密码',
            applicationNotes:'应用说明',
            dataSatName:'数据集名称',
            dataSize:'数据大小',
            dataId:'数据标识',
            createTime:'创建时间',
        },
        tip:{
            deleteSelectFile:'确定删除已选数据集文件？',
            downloadTheFile:'确定下载该文件？',
            deleteTheFile:'确定删除该文件？',
            dataReservation:'预定数据',
            projectName:'任务名称',
            applicationNotes:'应用说明',
            download:'下载',
            cancel:'取 消',
            confirm:'确 认',
            seleteDataEntry:'请选择数据',
            PleaseFill:'请填写相关信息',
            reservationSuccess:'数据预定成功',
            deleteSelectOrder:'确定删除已选订单？',
            deleteTheOrder:'确定删除该订单么？',
            order:'订单信息',
            delete:'删除',
            orderNum:'订单编号',
            status:'状态',
            adrees:'FTP地址',
            FTPaccount:'FTP账号',
            FTPpassword:'FTP密码',
            uncollectSelectDatasat:'确定取消收藏已选数据集？',
            uncollecttheDatasat:'确定取消收藏该数据集？',
        }
    },
    DataDetails:{
        Description:'专项内共享,暂不支持下载',
        Use:'用途',
        Present:'有',
        NotPresent:'无',
        tip:{
            dataEntry:'请选择数据',
            successfully:'数据添加成功',
            collectSuccessfully:'数据集收藏成功',
            failure:'数据添加失败,请联系管理员！',
            downloadData:'确定下载当前数据?',
            cancel:'取消',
            confirm:'确定'
        },
        collectionDatasets:'收藏数据集',
        dataHub:'数据服务',
        dataContributors:'数据贡献者',
        latestUpdate:'最新更新时间',
        storageVolume:'存储量',
        visits:'数据访问量',
        downloads:'数据下载量',
        mateInfo:{
            sharing1:'专项内共享',
            sharing2:'公开共享',
            basicInformation:'基本信息',
            productNumber:'产品编号',
            dataType:'数据类型',
            dataFormat:'数据格式',
            Projection:'投影方式',
            startDate:'开始日期',
            endDate:'结束日期',
            spatialResolution:'空间分辨率',
            timeResolution:'时间分辨率',
            geographicalScope:'地域范围',
            sharingMethod:'共享方式',
            createInstitution:'创建机构',
            createdBy:'创建人员',
            creationDate:'创建日期',
            dataLabel:'关键字',
            sdgGoal:'SDGs目标',
            processingMethod:'加工方法',
            QuoteAddress:'引用地址',
            copyrightNotice:'版权声明',
            subProjectNumber:'子课题编号',
            dataObject:'数据对象',
            dataIdentification:'数据标识',
            Description:'简介',
            subjectClassification:'学科分类',
            format:'格式',
            scopeDescription:'范围说明',
            releaseAgency:'发布机构',
            Email:'邮箱',
            Phone:'电话',
            latestRelease:'最新发布日期',
            totalStorage:'总储存量',
            totalFiles:'总文件数',
            dateScope:'时间范围',
            resolution:'分辨率',
            copyright:'版权',
            creatingInformation:'创建信息',
            releaseNews:'发布信息',
            updateDate:'更新时间',
            fileInformation:'文件信息',
            productType:'产品类型',
        },
        close:'关闭',
        metadataDetails:'元数据详情',
        downloadMetadata:'下载元数据',
        relatedResources:'相关资源',
        localFiles:'本地文件',
        serviceRecord:'服务记录',
        relatedDocuments:'相关文献',
        addCart:'添加到购物车',
        spaceLocation:'空间位置',
        lookOtherData:'看过该数据的人还看了',
        relatedRecommendations:'相关推荐',
        noData:'暂无数据'
    },
    DataHub: {
        NotDownload:'该数据暂不支持下载',
        Filter:'筛选',
        Services: '数据服务',
        Key: '关键字',
        Search: '搜索',
        TopSearch: '热门搜索',
        Select: '您已选择',
        Goal: 'SDGs目标',
        Format: '数据格式',
        Keywords: '关键字',
        Source: '数据来源',
        Clear: '重置',
        Close:'关闭',
        All: '全选',
        Mechanism: '发布机构',
        Date: '创建日期',
        MoreData: '向下滚动加载更多',
        NoData: '暂无更多数据'
    },
    DataInfo2:{
        IdentityInformation:'标识信息',
        Id:'标识符',
        Key:'关键词',
        provider:'提供者',
        DataType:'数据集分类',
        Source:'数据集来源',
        DataSetFormat:'数据集格式',
        ReleaseDate:'发布日期',
        DataSetDescriptionInformation:'数据集描述信息',
        DataSetName:'数据集名称',
        GeographicPosition:'地理位置',
        SpatialReference:'空间参照系',
        Spatial:'空间分辨率',
        DistributeandAccessInformation:'分发与访问信息',
        ContactName:'联系人姓名',
        Phone:'电话',
        Email:'邮箱',
        Address:'地址',
        PostCode:'邮编',
        Permission:'使用权限',
        
    },
    DataInfo: {

        Overview: '概述',
        File: '本地文件',
        Map: '地图',
        Introduction: '数据简介',
        Address: '引用地址',
        Basic: '基本信息',
        Start: '开始日期',
        End: '结束日期',
        Spatial: '空间分辨率',
        Temporal: '时间分辨率',
        Territorial: '地域范围',
        Share: '共享方式',
        Public: '公开共享',
        Copyright: '版权声明：本数据仅可免费用于学术用途和其他非商业用途。未经事先许可，不得重新发行或用于商业用途。使用本产品的用户应明确标明来源及作者。',
        Development: '正在开发中,敬请期待',
        CreateDate: '创建日期',
        fileNmu: '文 件 量',
        seeNum: '浏 览 量',
        download: '下 载 量',
        downloadBtn: '下载',
        otherData: '看过数据的人还看了',
        Recommend: "相关推荐",
        Operation: '操作'
    },
    App: {
        ExternalApp:'外部应用',
        app9:'海南省可持续发展综合决策支持平台',
        app5:'全球农情遥感监测云服务平台',
        app6:'自然-文化遗产监测与评估信息服务系统',
        app7:'工程项目遥感实时监测系统',
        app8:'国际灾害数据库数据自动获取模块',
        Market: '应用市场',
        welcome: '欢迎来到⼤数据系统应⽤市场！',
        SDGs: '系统紧密围绕SDG的17个目标，以世界银行、WHO、联合国、维基百科等机构的全球统计数据为基础数据源，通过对可持续发展目标指标体系的分析，完成各种数据产品的解析和预处理、多源数据的融合计算，实现SDGs指标量化评估与多维度可视化展示。',
        SatEYE: '系统多源空间信息产品的支持下，实现一带一路自然资源、生态环境、气候变化与灾害、社会经济等关键要素、现象及其变化过程的集成化数字再现，在 web 端支持交互展示及实现各类关键要素的浏览、查询、统计、制图等功能，为一带一路区域提供更为方便的数据展示及共享应用',
        Fire: '系统通过对卫星数据的处理分析以及火点监测算法、火势蔓延模型等的应用，实现火点信息的常态化监测以及火情的及时发现，及早核查，尽快处理。',
        COVIDTracker: '系统通过对疫情数据、舆情数据、社会经济数据、环境数据等的收集与整理，通过疫情的预测模型、人员的迁徙模型等模型的应用，实现对疫情新增和分布的可视化、疫情发展趋势的预测，从而为疫情的探测、传播预测以及风险评估提供有效的支撑。',
        app0:'依托海南省可持续发展基础数据库，集成海南省SDGs指标综合评估方法与决策支持模型，针对海南省SDG3、SDG4、SDG6、SDG11、SDG13、SDG14、SDG15中十余种指标进行状态监测、变化趋势研判与评估，面向海南省政府与行业部门提供SDGs指标监测、指标评估与决策支持服务。',
        app1:'系统具有下述工程项目遥感监测服务功能：工程对保护区影响分析，工程对生态环境影响监测，工程建设进度监测和社会经济影响监测；工程相关项目、服务等数据增删改查管理、工程相关数据购买、报告发送等功能',
        app2:'研制“一带一路”重大灾害信息网络自动采集模块，包括如下功能模块：(1)最新灾害事件新闻数据的实时网络爬虫抓取模块 (2)国际灾害数据库历史灾害事件数据获取(3)国际灾害事件数据库分析与展示。',
        app3:'系统提供遥感影像、地形、三维模型、矢量、图片、视频等多源海量数据的加载和展示，提供遗产地健康状态评估、遗产地适宜性变化趋势评估等，适用于国家、省等不同级别的遗产地动态监测管理和应用。',
        app4:'平台包含全球农情遥感监测计算（CropWatch Pro）、全球农情遥感监测信息在线浏览（CropWatch Explorer）、全球农情遥感速报在线分析（CropWatch Analysis）与在线发布（CropWatch Bulletin）在内的四大模块，基于最新遥感数据、气象数据、地面观测数据，评估国家及全球尺度的作物长势、产量等相关信息。',
        learnMore: '进入应用',
        NoMobile:'暂不支持手机版本访问'

    },
    Reports: {
        Reports: 'SDGs报告：跟踪可持续发展目标的进展',
        Description: '良好的数据和明确的指标对于每个国家评估其在可持续发展目标方面的立场、制定实现目标的途径和跟踪进展情况至关重要。自 2016 年以来，SDSN 和贝塔斯曼基金会发布了年度全球可持续发展目标指数和仪表板。该方法已经过同行评审，并于 2019 年由欧盟委员会联合研究中心审核。为了更好地分析国家和区域背景并提高政策相关性，SDSN 与众多合作伙伴合作开发了区域和次国家可持续发展目标指数和仪表板。',
        Download: '下载报告',
        online: '在线预览',

    },
    NewList: {
        New: 'SDGs故事',
        Society: 'SDGs与社会',
        Science: 'SDGs与科技',
        Practices: '实践案例',
        Active: '新闻',
        Time: '选择时间',
        Goal: '选择SDGs目标',
        Search: '搜索',
        Reset: '重置',
        NoData: '暂无更多数据',
        More: '更多',
        LearnMore: '了解详情',
        Share: '分享',
        Report: 'SDGs报告',
        Video: 'SDGs视频',
        SocietyDescription: '社会可持续发展是通过了解公民对社会生活和工作的需求，创造促进社会福祉的可持续过程。社会文化生活的基础设施、社会设施、公民参与以及人和地方发展的空间是社会可持续发展进程的衡量指标。2030 年议程及其 17 项可持续发展目标的综合性质要求在国家、区域和国际层面加强政策连贯性，这可以通过加强社会科学研究和公共政策制定之间的联系来实现。',
        ScienceDescription: '科技的可持续是指为提高效率而应用于可持续性活动和行动的技术，考虑自然资源并促进经济和社会发展的创新，目标是大幅降低环境和生态污染，并创造可持续的资源。技术正在塑造可持续性并实现更高水平的生产力和效率，大多数组织正在探索如何整合新技术和新措施，以推进其社会生态发展和框架，遵循联合国大会制定的可持续发展目标 (SDG)的目标，有望在 2030 年实现。',
        CaseDescription: '通过可持续发展实践案例，介绍社会各界在2020年至今推广的全球17项可持续发展目标的良好实践方法，实践案例收集了一系列关于“如何”实现世界可持续发展目标和推进 17 个可持续发展目标的最佳做法，分享各国如何在水、能源、可持续城市发展、生物多样性和环境方面实施可持续发展目标，展示了可持续发展目标实施方面的良好做法和成功案例。',
        Filter: '筛选',
        Tpye: '请选择新闻类型',
        Ok: '确定',
        Canel: '取消',
        UnderDevelopment: '正在开发中',
        Goal1: '无贫穷',
        Goal2: '零饥饿',
        Goal3: '良好健康与福祉',
        Goal4: '优质教育',
        Goal5: '性别平等',
        Goal6: '清洁饮水和卫生设施',
        Goal7: '经济适用的清洁能源',
        Goal8: '体面工作和经济增长',
        Goal9: '产业、创新和基础设施',
        Goal10: '减少不平等',
        Goal11: '可持续城市和社区',
        Goal12: '负责人消费和生产',
        Goal13: '气候行动',
        Goal14: '水下生物',
        Goal15: '陆地生物',
        Goal16: '和平、正义与强大机构',
        Goal17: '可持续发展目标',



    },
    Articles: {
        Like: '你可能还喜欢',
        Other: '其他新闻',
        Home: '首页',
        Details: '详情'
    },
    PublicComponents: {
        Cookie: {
            Cookie: '我们使用cookies，这对您访问我们的网站和向您提供我们的服务至关重要，使我们能够衡量和改善我们的网站的性能。',
            Accept: '接受所有Cookie',
            AcceptOnly: '接受部分Cookie'
        },
        ModuleTitle: {
            More: '更多'
        },
        Loading:{
            Loading:'正在加载中' 
        },
        Footer: {
           
            Nav: '导航',
            DataHub: '数据服务',
            Society: '可持续发展目标与社会',
            Science: '可持续发展目标与科学',
            Practices: '实践案例',
            Knowledge: '可持续发展目标知识库',
            Link: '相关链接',
            Link1: '地球大数据专项',
            Link2: '地球大数据云服务平台',
            Link3: '可持续发展⼤数据国际研究中⼼',
            Link4: 'SDG大数据平台',
            Link5: '中国科学院计算机网络信息中心',
            ContactUs: '联系我们',
            Email: '邮箱',
            Address: '地址',
            AddressInfo: '北京市海淀区邓庄南路9号',
            WeChat: '可持续发展大数据国际研究中心',
            Copyright: '版权所有@地球⼤数据科学⼯程/数字⼀带⼀路计划 ',
            Copyright2:'京ICP备17072443号',
            Postcode:'邮编',
            Phone:'电话'

        }
    },
    User: {
        Header: {
            Title: '一带一路地球大数据分析与决策支持系统',
            Home: '首页',
        },
        Login:{
            UserName:'用户名',
            Password:'密码',
            TipUserName:'请输入用户名',
            TipPassword:'请输入密码',
            ErrUserName:'用户名不能为空',
            ErrPassword:'密码不能为空',
            Login:'登录',
            Register:'注册',
            Forget:'忘记密码'
        },
        Register:{
            UserName:'用户名',
            Email:'邮箱',
            Code:'验证码',
            Password:'密码',
            ConfirmPassword:'确认密码',
            TipUserName:'请输入用户名',
            TipEmail:'请输入邮箱',
            TipCode:'请输入验证码',
            TipPassword:'请输入密码',
            TipConfirmPassword:'请确认密码',
            Login:'登录',
            Register:'注册',
            Forget:'忘记密码',
            GetCode:'获取验证码',
            OK:'确定'
        },
        Forget:{
            UserName:'用户名',
            Email:'邮箱',
            Code:'验证码',
            Password:'密码',
            ConfirmPassword:'确认密码',
            TipUserName:'请输入用户名',
            TipEmail:'请输入邮箱',
            TipCode:'请输入验证码',
            TipPassword:'请输入密码',
            TipConfirmPassword:'请确认密码',
            Login:'登录',
            Register:'注册',
            Forget:'忘记密码',
            GetCode:'获取验证码',
            OK:'确定'
        }


    },
    Verification:{
        EmailRegistered:'邮箱已注册',
        EmailErr:'邮箱格式不正确',
        UserNameRegistered:'账号已注册',
        UserNameNotExist:'用户不存在',
        Err:'操作失败',
        getCode:'获取验证码',
        OK:'成功',
        LoginErr:'用户名或密码不正确',
        LoginOk:'登录成功'

    },
    About:{
      title:'可持续发展大数据国际研究中心',
      title_brief:'中心简介',
      brief:'可持续发展大数据国际研究中心（简称：SDG中心）是全球首个以大数据服务2030年议程的国际科研机构。中心依托于中国科学院进行建设，瞄准地球系统科学、社会经济科学和可持续发展科学的交叉前沿领域，开展大数据驱动的环境公域、城乡发展、粮食安全和能源脱碳等领域监测、评估与预测的系统研究，发展大数据服务2030年议程的理论体系和技术方法，研建服务可持续发展目标的大数据平台和决策支持系统，为解决我国和全球重大可持续发展问题提供基础理论、技术方法、决策支持和智库服务支撑。',
      title_position:'中心定位',
      position:'面向推动联合国可持续发展目标全球落实的重大需求，以联合国可持续发展技术促进机制为牵引，构建大数据支撑可持续发展目标的理论、方法与技术体系，建立开放共享的数字地球科学平台，引领全球可持续发展大数据学科发展，为联合国相关机构、成员国和中国提供全方位数据共享、科技支撑和决策支持服务，建设成为国际一流的综合性研究机构。',
      title_target:'建设目标',
      target1:'SDG中心的目标是建成可持续发展大数据公共科技平台和研究机构，是可持续发展科学研究中心、数据信息服务与技术创新中心、全球可持续发展高端智库、人才培养与培训能力建设中心，服务联合国相关机构和成员国落实2030年议程。',
      target2:'SDG中心是国际地球大数据支撑可持续发展目标实现研究的引领者，联合国科技创新促进可持续发展目标在线平台的合作方，“一带一路”发展中国家可持续发展大数据方法的传播者，科技创新促进可持续发展目标实现的推动者。',
      title_active:'五项行动',
      active_title_1:'研发和建设SDG大数据平台',
      active_text_1:' 研建应用高性能计算、大数据分析、人工智能等技术的集存储、计算和云服务多功能于一体的SDG大数据平台系统，形成大数据支撑SDG指标监测、评估和监测，以及数据获取、产品生产和分发共享的一站式服务的基础设施平台。',
      active_title_2:'研制和运行SDG科学卫星',
      active_text_2:' 针对SDG各指标的特定需求，规划、研制和运行SDG系列地球科学卫星，为SDG的全球实现提供专属数据源。',
      active_title_3:'开展SDG指标监测与评估科学研究',
      active_text_3:'针对SDG指标体系的特点，开展大数据驱动的技术方法和理论体系科学研究，为服务2030年议程提供技术支撑和理论指导。',
      active_title_4:'建设科技创新促进可持续发展智库',
      active_text_4:'针对2030年议程实施过程中面临的问题，开展服务SDG实现的科技咨询和智库能力建设，为联合国相关机构提供科技咨询和决策支持服务，为联合国各成员国提供科技支撑，为我国可持续发展战略提供顶层设计和评价指标体系。',
      active_title_5:'提供面向发展中国家的教育和培训',
      active_text_5:'依托SDG中心和相关科研教学队伍及支撑平台，面向发展中国家，特别是“一带一路”区域的发展中国家和地区，提供专业人才教育培养和培训。'
    },
    Contact:{
        Name:'可持续发展大数据国际研究中心',
        Addres:'地址',
        Postcode:'邮编',
        Phone:'电话',
        Fax:'传真',
        NetWork:'网址',
        Email:'Email',
        AddresText:'北京市海淀区邓庄南路9号',
        PostcodeText:'100094',
        PhoneText:'+86-10-82178985',
        FaxText:'+86-10-82178980',
        NetWorkText:'sdg.casearth.cn',
        EmailText:'secretariat@cbas.ac.cn',

    },
    // ---------------------



















    login: {
        account: '用户名',
        password: '密码',
        forget: '忘记密码',
        login: '登录',
        register: '注册',
        loginError: '用户名或密码不正确',
        tip1: '请输入用户名',
        tip2: '请输入密码'
    },
    register: {
        register: '注册',
        account: '用户名',
        email: '邮箱',
        code: '验证码',
        getCode: '获取验证码',
        password: '密码',
        confirmPassword: '确认密码',
        forget: '忘记密码',
        login: '登录',
        tip1: '请输入用户名',
        tip2: '请输入密码',
        tip3: '请输入邮箱',
        tip4: '请输入验证码',
        tip5: '请确认密码',
        checkLogin: '用户名已被注册,请重新输入',
        checkEmail: '邮箱已被注册,请重新输入',
        LoginNameErr: '用户名不能为空',
        emailErr: '邮箱格式不正确',
        accountRegular: '用户名4到16位（字母，数字，下划线）',
        passwordRegular1: '密码由6-14数字加字母组成',
        passwordRegular2: '密码不能为空',
        passwordRegular3: '两次密码不一致',
        codeRegular: '请输入验证码',
        emailRegular1: '邮箱格式不正确',
        emailRegular2: '邮箱不能为空',
    },
    forget: {
        login: '登录',
        account: '用户名',
        email: '邮箱',
        code: '验证码',
        getCode: '获取验证码',
        password: '密码',
        confirmPassword: '确认密码',
        forget: '忘记密码',
        submit: '确定',
        tip1: '请输入用户名',
        tip2: '请输入密码',
        tip3: '请输入邮箱',
        tip4: '请输入验证码',
        tip5: '请确认密码'
    },
    forgetPassword: {
        forgetPassword: '忘记密码',
        toLogin: '前往登录',
        submit: '提交',
        loginNameErr1: '用户名不能为空',
        loginNameErr2: '用户名4到16位（字母，数字，下划线）',
        passwordErr1: '密码由6-14数字加字母组成',
        passwordErr2: '密码不能位空',
        passwordErr3: '两次密码不一致',
        codeErr: '请输入验证码',
        codeErr1: '验证码输入错误',
        emailErr1: '邮箱格式不正确',
        emailErr2: '邮箱不能为空',
        emailErr3: '邮箱已被注册',
        passtip: '密码修改成功',

    },
    // 数字丝路地球大数据平台
    title: '一带一路地球大数据分析与决策支持系统',
    knowledgeBase: {
        sdgs: 'SDGs',
        indicatorSystem: '指标体系',
        story: '数据与故事',
        link: '链接',
        indicator: '指标',
        series: '系列',
        country: '国家',
        target: '具体目标',
        progress: '进展情况',
        goal: '目标实现',
        nodata: '该指标国家暂无数据',
        selectCountry: '选择国家',
        confirm: '确定',

    },
    nav: {
        home: '首页',
        share: '数据共享',
        market: '应用市场',
        tipPhone: '移动版本暂未开放，敬请期待!'
    },
    titleList: {
        nav: '导航',
        breakingNews: ' 最新动态',
        socialEconomy: 'SDGs与科技',
        scientificResearch: '实践案例',
        practicalCase: 'SDGs与社会',
        knowledgeBase: 'SDGs知识库',
        language: '语言',
        more: '更多'
    },
    SDG: {

        indicatorsVisualization: 'SDGs数据窗口',
        evaluationreport: 'SDGs报告',
        indicatorsDatabase: 'SDGs指标知识库',


    },
    report: {
        reportSDGs: 'SDGs报告',
        version: '版本'
    },
    new: {
        title: 'SDGs新闻',
        relatedNews: '相关新闻',
        oldNews: '往日新闻'
    },
    link: {
        email: '邮箱: ',
        relatedLinks: "相关链接",
        link1: '可持续发展大数据国际研究中心',
        link2: '中国科学院计算机网络信息中心',
        link3: '地球大数据科学工程',
        link4: '地球大数据云服务系统',
        link5: '联合国可持续发展目标网站',
        link6: "地球大数据科学工程专项/数字丝路国际科学计划",
        contactUs: '联系我们',
        address: '北京市海淀区邓庄南路9号遥感楼A1005',
        Copyright: '版权所有@地球大数据科学工程专项/数字一带一路(DBAR)专项 京ICP备17072443号'
    },
    cookie: {
        cookie: '我们使用cookies，这对您访问我们的网站和向您提供我们的服务至关重要，使我们能够衡量和改善我们的网站的性能。',
        accept: '接受所有Cookie',
        acceptOnly: '接受部分Cookie'
    },
    learnMore: '了解更多',
    relatedNews: '相关新闻',
    SDGRelatedInformation: 'SDG相关资讯',
    filter: '过滤器',
    SDGAttribution: 'SDGs目标',
    dataCategory: '数据格式',
    ecologicalAttributes: '关键词',
    dataSources: '数据来源',
    label: '标签',
    creationDate: '创建日期',
    resolution: '分辨率',
    dataItem: '数据条目',
    FireForecastingSystem: '火灾预测预报系统',
    terraViewSatEye: 'TerraView-SatEYE是一个在线地图工具，用于为政府、企业和公众提供海量空间数据的便捷访问方式，促进数据的开放和共享。',
    terraViewFire: '森林火灾会对人、财产和野生动物造成危险，对森林的健康至关重要，TerraView-Fire利用遥感卫星探测全球范围内的火点并提供历史火灾数据以及火灾事件的统计分析。',
    COVIDTracker: '该应用通过收集、整理COVID-19相关数据，提供了一个从多维度了解全球疫情分布情况及变化趋势的可视化窗口，并实现报表的定制和输出。',
    terraViewSDG: '该应用通过收集、整理SDG相关数据，提供SDG指标全球尺度的可视化、SDG指标计算数据的浏览、SDG指标的对比分析以及可视化图表的定制与输出。',

    loading: {
        all: '数据已加载全部',
        more: '加载更多数据',
        loading: '正在加载中',
        loading1: '加载中'
    },
    crumbs: {
        home: '首页'
    },
    dataShare: {
        all: "全选",
        deselectAll: '取消全选',
        result: '1-正在显示10个结果，共45个结果',
        update: '更新日期',
        create: '创建日期',
        relevancy: '相关度',
        imageDatasets: '影像数据集',
        featureDatasets: '矢量数据集',
        forms: '表格数据集',
        atmospheric: '大气属性',
        vegetationCoverage: '植被覆盖度',
        ecologicalAttributes: '生态属性',
        availableDate: '可用日期',
        key: '关键字',
        spatialResolution: '空间分辨率',
        sources: '数据来源',
        label: '标签',
        dataItem: '数据条目',
        dateCreated: '创建日期',
        show: '显示',
        back: '返回',
        dataShare: '数据共享',
        createTime: '创建日期',
        releaseMech: '发布机构',
        SDGsGoal: 'SDGs'
    },
    info: {
        spheres: '圈层',
        spatialResolution: '空间分辨率',
        temporalResolution: '时间分辨率',
        territorialScope: '地域范围',
        sdg: 'SDG目标',
        createInstitutions: '创建机构',
        creator: '创建者',
        creationTime: '创建时间',
        dataItem: '数据条目',
    },
    search: {
        placeholder: "请输入检索条件",
        search: '搜索'
    },
    sdgDataBase: {
        sdg: {
            title: '17个可持续发展目标是实现所有人更美好和更可持续未来的蓝图。目标提出了我们面临得全球挑战，包括与贫困、不平等、气候、环境退化、繁荣以及和平与正义有关的挑战。这些目标相互关联，旨在不让任何一个人掉队，我们必须在2030年之前实现每个目标',
            GOAL1: '无贫穷',
            GOAL1Value: '在全世界消除一切形式的贫困',
            GOAL2: '零饥饿',
            GOAL2Value: '消除饥饿，实现粮食安全，改善营养状况和促进可持续农业',
            GOAL3: '良好健康与福祉',
            GOAL3Value: '确保健康的生活方式，促进各年龄段人群的福祉',
            GOAL4: '优质教育',
            GOAL4Value: '确保包容和公平的优质教育，让全民终身享有学习机会',
            GOAL5: '性别平等',
            GOAL5Value: '性别平等不仅是一项基本人权，而且是和平、繁荣和可持续世界的基石',
            GOAL6: '清洁饮水和卫生设施',
            GOAL6Value: '为所有人提供水和环境卫生并对其进行可持续管',
            GOAL7: '经济适用的清洁能源',
            GOAL7Value: '确保人人获得负担得起的、可靠和可持续的现代能源',
            GOAL8: '体面工作和经济增长',
            GOAL8Value: '促进持久、包容和可持续经济增长，促进充分的生产性就业和人人获得体面工作',
            GOAL9: '产业、创新和基础设施',
            GOAL9Value: '基础设施投资对实现可持续发展至关重要',
            GOAL10: '减少不平等',
            GOAL10Value: '减少国家内部和国家之间的不平等',
            GOAL11: '可持续城市和社区',
            GOAL11Value: '建设包容、安全、有抵御灾害能力和可持续的城市和人类住区',
            GOAL12: '负责任消费和生产',
            GOAL12Value: '产业、创新和基础设施',
            GOAL13: '气候行动',
            GOAL13Value: '气候变化是跨越国界的全球性挑战',
            GOAL14: '水下生物',
            GOAL14Value: '保护水下生物',
            GOAL15: '陆地生物',
            GOAL15Value: '可持续管理森林，防治荒漠化，制止和扭转土地退化，遏制生物多样性的丧失',
            GOAL16: '和平、正义与强大机构',
            GOAL16Value: '让所有人都能诉诸司法，在各级建立有效、负责和包容的机构',
            GOAL17: '促进目标实现的伙伴关系',
            GOAL17Value: '重振可持续发展全球伙伴关系',
        },
    }

}
